// Recorder options
export const DESKTOP = 'desktop';
export const CHROME_EXTENSION = 'chrome-extension';
export const SDK = 'sdk';
